import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FileUsageResponse } from '../../Models/Models';
import DiscardButton from '../Buttons/DiscardButton';
import DeleteButton from '../Buttons/DeleteButton';
import { Link } from 'react-router-dom';
import { FileService } from '../../Services/FileService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { SiteContext } from '../../Contexts';

interface Props {
    show: boolean;
    onHide: () => void;
    onSubmit: () => void;
    fileName?: string;
    idToDelete: number;
}

const FileDeleteModal: React.FC<Props> = ({ show, onHide, onSubmit, fileName, idToDelete }) => {
    const { checkFileUsage } = FileService();
    const [usageData, setUsageData] = useState<FileUsageResponse | null>(null);
    const { currentSite }: any = useContext(SiteContext);

    useEffect(() => {
        if (!show || idToDelete === 0) return;
        setUsageData(null);
        void (async () => setUsageData(await checkFileUsage(idToDelete)))();
    }, [show, idToDelete]);

    const usages = usageData?.posts ?? [];

    return (
        <Modal show={show} onHide={onHide} centered>
            <div className="st-delete-modal-stripe" />
            <Modal.Header className="st-delete-modal-header">
                <div className="st-delete-modal-header-inner">
                    <div className="st-delete-modal-icon-badge">
                        <FontAwesomeIcon icon={faTrash} className="st-delete-modal-icon" />
                    </div>
                    <span className="st-delete-modal-title">Zmazať súbor?</span>
                </div>
            </Modal.Header>

            <Modal.Body className="st-delete-modal-body">
                {!usageData ? (
                    <p className="text-secondary mb-0">Načítavam...</p>
                ) : usages.length === 0 ? (
                    <p className="st-delete-modal-description">
                        Naozaj chcete zmazať súbor {fileName ? `„${fileName}“` : ''}? Túto operáciu nie je možné vrátiť naspäť.
                    </p>
                ) : (
                    <div className="st-delete-modal-warning-box st-delete-modal-warning-box--amber">
                        <div className="st-delete-modal-warning-inner">
                            <FontAwesomeIcon icon={faTriangleExclamation}
                                className="st-delete-modal-warning-icon st-delete-modal-warning-icon--amber" />
                            <div>
                                <p className="st-delete-modal-warning-title st-delete-modal-warning-title--amber">
                                    Súbor je použitý {usages.length > 1 ? 'v týchto príspevkoch:' : 'v tomto príspevku:'}
                                </p>
                                <ul className="st-delete-modal-warning-list">
                                    {usages.map(post => (
                                        <li key={post.id}>
                                            <Link target="_blank"
                                                to={`/post/edit/${post.id}?websiteId=${currentSite.id}`}
                                                className="st-link-amber">
                                                {post.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                                <p className="st-delete-modal-warning-note">
                                    Zmazaním súboru sa odkaz na súbor v týchto príspevkoch odstráni. Príspevky zostanú zachované.
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer className="st-delete-modal-footer">
                <DiscardButton onClick={onHide} />
                <DeleteButton onClick={onSubmit} />
            </Modal.Footer>
        </Modal>
    );
};

export default FileDeleteModal;
